import { Edit } from './Edit';
import { View } from './View';
import circleMenuSVG from '@plone/volto/icons/circle-menu.svg';

export const buttonBlock = {
  id: '__iskra-button',
  title: 'Iskra button',
  icon: circleMenuSVG,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  security: {
    addPermission: [],
    view: [],
  },
};
